import type { TourDefinition } from '@renderer/hooks/useTour';

/**
 * Sprint 9.1 — Tour del Corte de Caja.
 * Sprint 26 — Actualizado tras Sprint 20 (wizard de billetes) y Sprint 24.
 * Sprint 48 — Reescrito: el paso 1 ahora es un contexto general (no apunta al
 * header que desaparece en modo embedded). Se agregan pasos para movimientos de
 * caja (Sprint 12.1b) y contador de billetes (Sprint 12+20).
 */
export const tourCorteCaja: TourDefinition = {
  id: 'corte_caja',
  title: 'Cómo abrir y cerrar caja',
  steps: [
    {
      element: '[data-tour="corte-seccion-principal"]',
      popover: {
        title: '1. Abrir o cerrar caja',
        description:
          'Si la caja está CERRADA, registras el fondo inicial (puede ser $0) y la abres para operar. Si ya está ABIERTA, aparece el resumen de ventas del día y las opciones de cierre. Esta misma pantalla vive dentro del wizard "Cerrar Día".',
        side: 'top',
      },
    },
    {
      element: '[data-tour="corte-movimientos"]',
      popover: {
        title: '2. Movimientos de caja',
        description:
          'Registra egresos (pagos a proveedores, gastos operativos) e ingresos (aportaciones) que no vienen de ventas. Cada movimiento queda en bitácora con su justificación. Afectan el efectivo esperado al cierre.',
        side: 'top',
      },
    },
    {
      element: '[data-tour="corte-contador-billetes"]',
      popover: {
        title: '3. Contar el efectivo (wizard de billetes)',
        description:
          'En lugar de sumar a mano, ingresa cuántos billetes de cada denominación tienes: $500, $200, $100, $50, $20 y monedas. El total se calcula solo. Compara contra el "efectivo esperado" para detectar sobrantes o faltantes.',
        side: 'top',
      },
    },
    {
      element: '[data-tour="corte-seccion-principal"]',
      popover: {
        title: '4. Cerrar la caja',
        description:
          'Agrega observaciones si necesitas (opcional) y presiona "Cerrar caja". El sistema genera un PDF con el resumen completo. Si hay propinas pendientes de repartir, te avisa antes de cerrar porque afectan el efectivo en gaveta. Requiere confirmación con PIN de dueño (2FA).',
        side: 'top',
      },
    },
  ],
};
